<template>
  <div class="objective-name" data-testid="objective-name">
    <Heading class="objective-name__heading" :level="2">
      Qual o nome do seu objetivo?
    </Heading>
    <SingleInput
      v-model="objectiveName"
      class="objective-name__single-input"
      placeholder="Ex: Casa na praia"
      show-clear-button
      :max-length="30"
      @keypress.enter.prevent="handleUpdateName"
      @on-clear="clearName"
    />
    <BaseText class="objective-name__counter" size="p6">
      {{ counter }}
    </BaseText>
    <ButtonContainer class="objective-name__button-container">
      <template #button-primary>
        <ButtonPrimary
          label="Continuar"
          size="large"
          :disabled="isDisabled"
          @click="handleUpdateName"
        />
      </template>
    </ButtonContainer>
  </div>
</template>

<script lang="ts" setup>
import { computed, inject, ref } from 'vue';

import {
  Heading,
  SingleInput,
  BaseText,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

const updateData = inject('updateData', (key: string, name: string) => ({
  key,
  name
}));

const objectiveName = ref('');

const isDisabled = computed(() => {
  return objectiveName.value.trim() === '';
});

const counter = computed(() => {
  return `${objectiveName.value.length}/30`;
});

function clearName() {
  objectiveName.value = '';
}

function handleUpdateName() {
  if (isDisabled.value) return;

  updateData('objectiveName', objectiveName.value);
}
</script>

<style lang="less" scoped>
.objective-name {
  max-width: 832px;
  margin: 0 auto;
  padding: 0 @size-spacing-x400 @size-spacing-x1800;

  &__heading {
    margin-top: @size-spacing-x1100;
  }

  &__single-input {
    margin-top: @size-spacing-x800;
  }

  &__counter {
    margin: @size-spacing-x300 0;
    text-align: right;
  }

  &__button-container {
    background-color: @background-secondary;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 20;
  }
}
</style>
